import { ts } from '_core';

import { getName, validate } from './helpers';
import { DraftParams } from './types';

export default [
  {
    key: ts.enums.REPORT_ENUMS.WIDGET_KEY_ENUM.SIGNAL_HISTOGRAM,
    title: 'Histogram',
    helpLabel: 'rr5q1hlu',
    form: true,
    defaultParams: {
      history: 'Full',
      num_bins: 100,
      percent: true,
      format_for_ui: true,
    } as DraftParams,
    neededFiles: ['signal_histogram'],
    tags: [
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.SIGNAL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.ALPHA_MODEL,
      ts.enums.REPORT_ENUMS.REPORT_TAG_ENUM.COMMON_ALPHA_MODEL,
    ],

    getName,
    validate,
  },
] satisfies ts.types.analysis.WidgetConfig[];
